
import * as OM from '@/model'
import { ProjectConfigClient } from '@/services/Services';
import store from '@/store';
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class personalData extends Vue {

    @Prop() item: OM.PersonalData;

}
